// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".U3MHHxTtIIEtV7QBKIgu{height:33px}", "",{"version":3,"sources":["webpack://./src/components/Error/ErrorFooter.scss"],"names":[],"mappings":"AAEA,sBACE,WAAA","sourcesContent":["@import '~@seismic/mantle/dist/sass/variables';\n\n.errorFooter {\n  height: calc(65px - 16px * 2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorFooter": "U3MHHxTtIIEtV7QBKIgu"
};
export default ___CSS_LOADER_EXPORT___;
